// Directory prices are stored as a number. The studio is in Riyadh, so every
// price on the public cards is Saudi Riyals — never a bare number.

export const isPriceField = (field) => {
  const key = String((field && field.key) || "").toLowerCase();
  return key.includes("price");
};

export const parseAmount = (value) => {
  if (value === null || value === undefined || value === "") return null;

  if (typeof value === "object" && value.label) {
    return parseAmount(value.label.ar || value.label.en || value.value);
  }

  const cleaned = String(value).replace(/[^\d.-]/g, "");
  if (cleaned === "" || cleaned === "-" || cleaned === ".") return null;

  const numeric = Number(cleaned);
  return Number.isFinite(numeric) ? numeric : null;
};

export const formatSar = (value, lng = "ar") => {
  const amount = parseAmount(value);
  if (amount === null) return value == null ? "" : String(value);

  // Western digits to match the rest of the site (VO-1003, phone numbers).
  const number = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
  }).format(amount);

  return lng === "en" ? `SAR ${number}` : `${number} ريال`;
};
